import { render, staticRenderFns } from "./stripeTerms.vue?vue&type=template&id=562a924c&scoped=true&"
import script from "./stripeTerms.vue?vue&type=script&lang=js&"
export * from "./stripeTerms.vue?vue&type=script&lang=js&"
import style0 from "./stripeTerms.vue?vue&type=style&index=0&id=562a924c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a924c",
  null
  
)

export default component.exports